<!-- <h1 mat-dialog-title>Hierarchy Location</h1> -->
<app-dialog-header headerText="Modify Location" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<mat-form-field>
			<mat-label>Name:</mat-label>
			<input matInput autocomplete="off" formControlName="Name" required>
			<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">
				<span>Name is required</span>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Description:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">
				<span>Description is required</span>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Parent Functional Location:</mat-label>
			<input matInput autocomplete="off" readonly="" formControlName="ParentFunctionalLocation" placeholder="parent location">			
		</mat-form-field>
		<mat-form-field>
			<mat-label>Function Location:</mat-label>
			<input matInput autocomplete="off" formControlName="FunctionalLocation" placeholder="Inherited from parent location if left empty">			
		</mat-form-field>
		<app-image-container [imgURL]="imageSrc" 
							 [enablePicture]="enablePicture"
							 [enableCamera]="enableCamera"
							 [enableDelete]="enableDelete"
							 (onDelete)="deleteImg()" 
							 (onNewImage)="onNewImage($event)"></app-image-container>			
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
